import { render } from "./ReturnOrderListComponent.vue?vue&type=template&id=7f21d220&scoped=true"
import script from "./ReturnOrderListComponent.vue?vue&type=script&lang=js"
export * from "./ReturnOrderListComponent.vue?vue&type=script&lang=js"

import "./ReturnOrderListComponent.vue?vue&type=style&index=0&id=7f21d220&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f21d220"],['__file',"resources/js/components/admin/returnOrders/ReturnOrderListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f21d220"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f21d220', __exports__)) {
    api.reload('7f21d220', __exports__)
  }
  
  module.hot.accept("./ReturnOrderListComponent.vue?vue&type=template&id=7f21d220&scoped=true", () => {
    api.rerender('7f21d220', render)
  })

}


export default __exports__